/* eslint-disable angular/timeout-service */
import { CustomEvent } from '../../utils/event-utils';

let MutationObserver = window.MutationObserver || window.webkitMutationObserver;

export const nodeChangeListenerServiceModule = angular
  .module('Q.services.node-change-listener', [])

  .factory('nodeChangeListener', function ($window) {
    /**
     * Listens to DOM changes on a given node using browser methods.
     *
     * @param node Node to listen on
     * @param fn {Function} Function to call on DOM changes
     * @returns {Function} Function to disconnect the listener
     */
    function listenForChanges(node, fn) {
      let stopListening = angular.noop;

      if (node instanceof angular.element) {
        node = node[0];
      }

      if (MutationObserver) {
        // listen for any subtree changes
        const mutationObserverOpts = {
          childList: true,
          characterData: true,
          attributes: true,
          subtree: true,
        };
        let observer = new MutationObserver(() => {
          observer.disconnect();
          let event = new CustomEvent('MutationEvent');
          fn(event);
          observer.observe(node, mutationObserverOpts);
        });
        observer.observe(node, mutationObserverOpts);

        stopListening = () => observer.disconnect();
      } else {
        let ignoringMutations = false;
        let subtreeDebounce = null;
        let subtreeTrigger = (event) => {
          if (subtreeDebounce) $window.clearTimeout(subtreeDebounce);
          subtreeDebounce = $window.setTimeout(() => {
            if (ignoringMutations) return;
            ignoringMutations = true;
            fn(event);
            subtreeDebounce = null;
            ignoringMutations = false;
          }, 10);
        };

        const $node = angular.element(node);
        $node.on('DOMSubtreeModified', subtreeTrigger);

        stopListening = () => $node.off('DOMSubtreeModified', subtreeTrigger);
      }

      return stopListening;
    }

    return {
      listen: listenForChanges,
    };
  });
